import { createAction, props } from '@ngrx/store';
import { Local, LocalForm } from '@models/.'
import { ResponseBadRequest } from '@interfaces/.';

export const STORE_FIND = createAction('[Store] Find', props<{ id: string }>());
export const STORE_FIND_ALL = createAction('[Store] Find All', props<{ name?: string, resellerId?: string, accountId?: string, stateId?: string, includesInactive?: boolean }>());

export const STORE_FIND_SUCCESS = createAction('[Store] Find Success', props<{ store: Local }>());
export const STORE_FIND_ALL_SUCCESS = createAction('[Store] Find All Success', props<{ storeList: Local[] }>());
export const STORE_CREATED_SUCCESS = createAction('[Store] Create Success', props<{ store: Local|null }>());

export const STORE_FAILURE = createAction('[Store] Failure', props<{ error: ResponseBadRequest }>());

export const STORE_UPDATE_LOADING = createAction('[Store] Update Loading', props<{ loading: boolean }>());
export const STORE_UPDATE_FORM = createAction('[Store] Update Form', props<{ storeForm: LocalForm }>());
export const STORE_UPDATE_SELECTED = createAction('[Store] Update Selected', props<{ storeSelected: string[] }>());
export const STORE_EDIT_MODE = createAction('[Store] Edit Mode', props<{ editMode: boolean, isEditing: boolean }>());
export const STORE_UPDATE_ID = createAction('[Store] Update Id', props<{ storeId: string|null }>());

export const STORE_CREATE_VIEW = createAction('[Store] Create View');
export const STORE_UPDATE_VIEW = createAction('[Store] Update View', props<{ storeId: string }>());

export const STORE_CREATE = createAction('[Store] Create');
export const STORE_UPDATE = createAction('[Store] Update');
export const STORE_REMOVE = createAction('[Store] Remove', props<{ id: string }>());
export const STORE_ACTIVATE = createAction('[Store] Activate', props<{ id: string, store: Local }>());
export const STORE_DEACTIVATE = createAction('[Store] Deactivate', props<{ id: string }>());

export const STORE_CREATE_COMPLETED = createAction('[Store] Create Completed');
export const STORE_UPDATE_COMPLETED = createAction('[Store] Update Completed');
export const STORE_REMOVE_COMPLETED = createAction('[Store] Remove Completed');
export const STORE_ACTIVATE_COMPLETED = createAction('[Store] Activate Completed');
export const STORE_DEACTIVATE_COMPLETED = createAction('[Store] Deactivate Completed');

export const STORE_RESET = createAction('[Store] Reset');
export const STORE_RESET_FORM = createAction('[Store] Reset Form');
export const STORE_RESET_ERROR = createAction('[Store] Reset Error');
export const STORE_CLEAR_STATE = createAction('[Store] Clear State');

export const STORE_CREATE_DUPLICATE = createAction('[Store] Create Duplicate', props<{ targetLocal?: string | null, originLocal?: string | null }>());

export const STORE_FIND_ALL_DROPDOWNS = createAction('[Store] Find All Dropdowns', props<{ accountId?: string }>());

export const STORE_FIND_ALL_DROPDOWNS_SUCCESS = createAction('[Store] Find All Dropdowns Success', props<{ storeListDropdowns: Local[] }>());
